<a class="cursor-pointer menuLink {{ item.bgcolor }}"
  (click)="item.children?.length ? onParentClick($event) : onItemSelected(item)" [ngClass]="{
    activeMenu: item.route ? router.isActive(item.route, true) : false,
    'parent-active': !item.route && item.children?.length && hasActiveRoute(item, router.url)
  }">
  <i-tabler class="routeIcon icon-18" name="{{ item.iconName }}"></i-tabler>
  {{langCode =='en'? item.nameEn :item.nameAr }}
  @if(item.children && item.children.length){
  <span class="down-icon d-flex m-l-auto">
    <mat-icon> expand_more </mat-icon>
  </span>
  }
</a>

@if(item.children && item.children.length){
<div class="childBox" [class.held-open]="isHeld">
  @for(child of item.children; track child){
  <app-horizontal-nav-item [item]="child" [depth]="(depth ?? 0) + 1" class="ddmenu">
  </app-horizontal-nav-item>
  }
</div>
}